// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2RYQy","row":"styles_row__3d8ST"};